import flatpickr from "flatpickr";
import rangePlugin from "flatpickr/dist/plugins/rangePlugin";
import route from "../route";

const minusYear = () => {
    const date = new Date();
    date.setFullYear(date.getFullYear() - 1);
    return date;
}

if (route === 'statement' || route === 'transactions') {

    flatpickr(".flatpickr-input", {
        enableTime: false,
        defaultDate: "today"
    });

    flatpickr(".from-date", {
        mode: "range",
        defaultDate: minusYear(),
        minDate: new Date(new Date().getFullYear() - 7, 0, 1),
        maxDate: "today",
        "plugins": [new rangePlugin({ input: ".to-date"})]
    });

    flatpickr(".from-today", {
        defaultDate: "today",
        minDate: "today",
    });
} else if (route === ("account-complete") || route === ("account-confirm-details") || route === ("livetrade-portfolio")) {
    flatpickr(".flatpickr-input", {
        enableTime: false,
        dateFormat: 'd/m/Y'
    });
} else {
    flatpickr(".flatpickr-input", {
        enableTime: false,
        defaultDate: "today",
        dateFormat: 'd/m/Y'
    });
}

// open calendar when icon is clicked
$(document).on("click", ".flatpickr-icon", function (e) {
    const $flatPickerInput = $(e.target).prev("input.flatpickr-input");
    if ($flatPickerInput && !$flatPickerInput.prop("disabled")) {
        $flatPickerInput.trigger("click");
    }
});
